export const PROTOCOL_NAME_EXTENSIONS = '.fast';

export const SignalRHub = {
  AUTHORING: 'authoring',
  LABWARE_DEFINITION: 'labwareDefinition',
  STATE: 'state',
  TRAY: 'tray',
  SESSION: 'session',
  USER_MANAGEMENT: 'userManagement',
  INSTRUMENT: 'instrumentcontrol',
  PROTOCOL: 'protocol',
  PROTOCOL_MANAGEMENT: 'protocolManagement',
  SOFTWARE_UPDATER: 'softwareUpdater',
  INSTRUMENT_MANAGEMENT: 'instrumentManagement',
  BACKUP_AND_RESTORE: 'backuprestore',
  HUMIDIFIER: 'humidifier',
};

export const SignalREvent = {
  // #region common
  HEARTBEAT: 'Heartbeat',
  SET_LED_INDICATOR: 'SetLEDIndicator',
  // #endregion common

  // #region state hub
  GET_PROTOCOL: 'GetProtocols',
  RENAME_PROTOCOL: 'RenameProtocol',
  SET_FAST_INFO: 'SetFastInfo',
  GET_LAST_FAST_INFO: 'GetLastFastInfo',
  SET_LICENSE_DATA: 'SetLicenseData',
  GET_LAST_LICENSE_DATA: 'GetLastLicenseData',
  // #endregion state hub

  // #region labwareDefinition hub
  GET_LABWARE_DEFINITIONS: 'GetLabwareDefinitions',
  SAVE_LABWARE_DEFINITIONS: 'SaveLabwareDefinition',
  // #endregion labwareDefinition hub

  // #region authoring hub
  GET_CONFIG: 'GetConfig',
  SET_TIPS_CADDY_DONE: 'SetTipsCaddyDone',
  PROGRESS_UPDATE: 'ProgressUpdate',
  RUNTIME_ERROR: 'RuntimeError',
  PAUSE_PROTOCOL_START: 'PauseProtocolStart',
  PAUSE_PROTOCOL_END: 'PauseProtocolEnd',
  RESUME_PROTOCOL_START: 'ResumeProtocolStart',
  RESUME_PROTOCOL_END: 'ResumeProtocolEnd',
  PIPETTE_TASK_EXEC_BEGIN: 'PipetteTaskExecBegin',
  ABORT_PROTCOL_START: 'AbortProtocolStart',
  PROTOCOL_DONE: 'ProtocolDone',
  EXECUTION_DONE: 'ExecutionDone',
  NEW_RUN_SESSION: 'NewRunSession',
  PRE_RUN_PROTOCOL_CONFIRMATION: 'PreRunProtocolConfirmation',
  IDENTIFY_CSV_VERSION: 'IdentifyCsvVersion',
  IDENTIFY_USED_PLATE_IN_PICKLIST: 'IdentifyUsedPlateInPickList',
  CONVERT_PICKLIST_TO_PROTOCOL: 'ConvertPickListToProtocol',
  PLATE_SWAPPED: 'PlateSwapped',
  // #endregion authoring hub

  // #region session hub
  DISSCONNECT_CLIENT: 'disconnectClient',
  SESSION_CHANGED: 'SessionChanged',
  USER_UPDATED: 'UserUpdated',
  CREATE_SESSION: 'CreateSession',
  UPDATE_SESSION: 'UpdateSession',
  DELETE_SESSION: 'DeleteSession',
  GET_SESSION: 'GetSession',
  BROADCAST_SESSION_CHANGED_EVENT: 'BroadcastSessionChangedEvent',
  GET_ACTIVE_USERS: 'GetActiveUsers',
  UPDATE_SESSION_ACTIVE_STATUS: 'UpdateSessionActiveStatus',
  IS_USER_BUSY: 'IsUserBusy',
  // #endregion session hub

  // #region instrumentcontrol hub
  GET_CURRENT_POSITION: 'GetCurrentPosition',
  FAST_HOMING: 'FastHoming',
  TRAY_DETACHED: 'TrayDetached',
  TRAY_ATTACHED: 'TrayAttached',
  TRAY_ATTACHED_HANDLING_DONE: 'TrayAttachedHandlingDone',
  RENAME_PROTOCOL_IN_TRAY: 'RenameProtocolInTray',
  GET_INSTALLED_TRAY: 'GetInstalledTray',
  GET_STATUS: 'GetStatus',
  SET_TRAY_ID: 'SetTrayId',
  GET_TRAY_DATA_BY_ID: 'GetTrayDataById',
  SAFE_FAST_RECOVERY: 'SafeFastRecovery',
  IS_TOUCH_PROBE_EXPANDED: 'IsTouchProbeExpanded',
  GET_ALL_MOTOR_STATUS: 'GetAllMotorStatus',
  ALIGN_TO_DECK_INSERT: 'AlignToDeckInsert',
  SAFE_ALIGN_TO_DECK_INSERT_WITH_EXTENDED_PROBE: 'SafeAlignToDeckInsertWithExtendedProbe',
  ALIGN_TO_DECK_INSERT_WITH_OFFSET: 'AlignToDeckInsertWithOffset',
  ALIGN_TO_DECK_CADDDY: 'AlignToDeckCaddy',
  ALIGN_X_Y_Z: 'AlignXYZ',
  CHECK_TIP_PICK_UP: 'CheckTipPickUp',
  SET_CADDY_BY_ID: 'SetCaddyById',
  SAFE_TOUCH_PROBE_RETRACT: 'SafeTouchProbeRetract',
  SAFE_AUTO_CALIBRATION: 'SafeAutoCalibration',
  GET_STATUS_AUTO_CALIBRATION: 'GetStatusAutoCalibration',
  PAUSE_AUTO_CALIBRATION: 'PauseAutoCalibration',
  RESUME_AUTO_CALIBRATION: 'ResumeAutoCalibration',
  ABORT_AUTO_CALIBRATION: 'AbortAutoCalibration',
  SET_CALIBRATION_DATA: 'SetCalibrationData',
  SAFE_TOUCH_PROBE_EXTEND: 'SafeTouchProbeExtend',
  SAFE_MOVE_TRAY: 'SafeMoveTray',
  EJECT_TRAY: 'TrayEject',
  SAFE_MOVE_VERTICAL_CARRIER: 'SafeMoveVerticalCarrier',
  SAFE_MOVE_HORIZONTAL_CARRIER: 'SafeMoveHorizontalCarrier',
  FORCE_MOVE_VERTICAL_CARRIER_RELATIVE: 'ForceMoveVerticalCarrierRelative',
  FORCE_MOVE_HORIZONTAL_CARRIER_RELATIVE: 'ForceMoveHorizontalCarrierRelative',
  FORCE_MOVE_TRAY_RELATIVE: 'ForceMoveTrayRelative',
  MOVE_TRAY_RELATIVE: 'MoveTrayRelative',
  MOVE_TRAY_RELATIVE_WITH_EXTENDED_PROBE: 'MoveTrayRelativeWithExtendedProbe',
  MOVE_VERTICAL_CARRIER_RELATIVE: 'MoveVerticalCarrierRelative',
  MOVE_VERTICAL_CARRIER_RELATIVE_WITH_EXTENDED_PROBE: 'MoveVerticalCarrierRelativeWithExtendedProbe',
  MOVE_VERTICAL_CARRIER_EXT: 'MoveVerticalCarrierExt',
  MOVE_HORIZONTAL_CARRIER_RELATIVE: 'MoveHorizontalCarrierRelative',
  MOVE_HORIZONTAL_CARRIER_RELATIVE_WITH_EXTENDED_PROBE: 'MoveHorizontalCarrierRelativeWithExtendedProbe',
  PAUSE_PROTOCOL: 'PauseProtocol',
  CLOSE_RUNTIME_VIEW: 'CloseRuntimeView',
  RESUME_PROTOCOL: 'ResumeProtocol',
  ABORT_PROTOCOL: 'AbortProtocol',
  SCAN_TIPS: 'ScanTips',
  VISION_SCAN_DONE: 'VisionScanDone',
  VISION_SCAN_TRAY_DONE: 'VisionScanTrayIdDone',
  PROTOCOL_CALCULATION_DONE: 'ProtocolCalculationDone',
  GET_DISPENSE_REPORT: 'GetDispenseReport',
  REMAINING_TIME_UPDATE: 'RemainingTimeUpdate',
  PERCENT_PROGRESS_BAR_UPDATE: 'PercentProgressUpdate',
  SCAN_TRAY_ID_SEQUENCE: 'ScanTrayIDSequence',
  SAFE_MOVE_TO_IDLE_POSITION: 'SafeMoveToIdlePosition',
  MEASURE_WELL: 'MeasureWell',
  EMERGENCY_STOP_TRIGGERED: 'EmergencyStopTriggered',
  ERROR_ON_IDLE_TRIGGERED: 'ErrorOnIdleTriggered',
  CLEAR_ALL_FAULTS: 'ClearAllfaults',
  COLLECT_FAST_INFO: 'CollectFastInfo',
  IS_TRAY_INSTALLED: 'IsTrayInstalled',
  SET_PROTOCOL_TIP: 'SetProtocolTip',
  SAFE_RECOVERY_PROBE: 'SafeRecoveryProbe',
  SIMULATE_PROTOCOL_ERROR: 'SimulateProtocolError',
  SIMULATE_MANUAL_ACTION_ERROR: 'SimulateManualActionError',
  UPDATE_CURRENT_RUN_PROTOCOL: 'UpdateCurrentRunProtocol',
  SAFE_SCAN_TRAY_ID: 'SafeScanTrayId',
  GET_STATISTIC_CONFIG: 'GetStatisticConfig',
  GET_STATISTIC_DOC: 'GetStatisticDoc',
  GET_TARGET_MAILS: 'GetTargetMails',
  UPDATE_CLIENT_ALIAS: 'UpdateClientAlias',
  UPDATE_TARGET_MAIL: 'UpdateTargetMail',
  CALIBRATE_COLLISION: 'CalibrateCollision',
  UPDATE_A1_OFFSET: 'UpdateA1OffsetUsingCurrentPosition',
  IS_A1_OFFSET_METADATA_EXIST: 'IsA1OffsetMetadataExist',
  IS_A1_OFFSET_CALIBRATED: 'IsA1OffsetCalibrated',
  CALIBRATE_SCAN_TIPS: 'CalibrateScanTips',
  CALIBRATE_SCAN_SLANTED_TIPS: 'CalibrateScanSlantedTips',
  CALIBRATE_SCAN_STUCK_TIPS: 'CalibrateScanStuckTips',
  PRE_MOVE_CALIBRATE_SCAN_STUCK_TIPS: 'PreMoveCalibrateScanStuckTips',
  POST_MOVE_CALIBRATE_SCAN_STUCK_TIPS: 'PostMoveCalibrateScanStuckTips',
  IS_SLANTED_DETECTION_SKIPPED: 'IsSlantedDetectionSkipped',
  GET_FAST_ERROR_CODE_NUMBER: 'GetFastErrorCodeNumber',
  VISION_COMPATIBILITY_CHECK: 'VisionCompatibilityCheck',
  AUTO_CALIBRATION_EXECUTE_DONE: 'AutoCalibrationExecuteDone',
  AUTO_A1_OFFSET_CALIBRATION_EXECUTION_DONE: 'AutoA1OffsetCalibrationExecutionDone',
  AUTO_A1_OFFSET_CALIBRATION_ERROR_ENCOUNTERED: 'AutoA1OffsetCalibrationErrorEncountered',
  GET_CURRENT_PROGRESS_AUTO_A1_OFFSET_CALIBRATION: 'GetCurrentProgressAutoA1OffsetCalibration',
  AUTO_A1_OFFSET_CALIBRATION_PROGRESS_UPDATE: 'AutoA1OffsetCalibrationProgressUpdate',

  MANUAL_RETEACH_PLATE_GET_STATUS: 'GetStatusManualPlateDefinition',
  MANUAL_RETEACH_PLATE_CHECK_LABWARE: 'ManualPlateDefinitionCheckLabware',
  MANUAL_RETEACH_PLATE_SCANNING_TIPS: 'ManualPlateDefinitionPart1',
  MANUAL_RETEACH_PLATE_RETURN_TIPS: 'ManualPlateDefinitionPart2',
  MANUAL_RETEACH_PLATE_SCANNING_TIPS_DONE: 'ManualPlateDefinition1ExecutionDone',
  MANUAL_RETEACH_PLATE_RETURN_TIPS_DONE: 'ManualPlateDefinition2ExecutionDone',
  RECOVERY_EJECT_AND_SCAN_STUCK_TIPS: 'RecoveryEjectAndScanStuckTip',

  LOAD_CELL_ERROR: 'LoadcellError',
  GET_LOAD_CELL_ERROR: 'GetLoadcellError',
  TRY_RECOVER_LOAD_CELL_ERROR: 'TryRecoverLoadcellError',

  IDLE_HUMIDITY_TEMPERATURE_UPDATE: 'IdleHumidityAndTemperatureUpdate',
  HUMIDIFIER_DOOR_OPEN: 'HumidifierDoorOpened',
  HUMIDIFIER_DOOR_CLOSED: 'HumidifierDoorClosed',
  IS_HUMIDIFIER_INSTALLED: 'IsHumidifierInstalled',
  IS_HUMIDIFIER_DOOR_OPENED: 'IsHumidifierDoorOpened',
  ENABLE_HUMIDIFIER: 'EnableHumidifier',
  SET_IDLE_HUMIDITY: 'SetIdleHumidity',
  IS_WATER_LEVEL_LOW: 'IsWaterLevelLow',
  WATER_LEVEL_CHANGE: 'WaterLevelChange',
  HUMIDITY_DROPPED: 'HumidityDropped',
  IGNORE_HUMIDITY_DROP: 'IgnoreHumidityDrop',
  IS_IDLE_HUMIDITY_ENABLE: 'IsIdleHumidityEnable',
  IDLE_HUMIDITY_TARGET: 'IdleHumidityTarget',
  ENABLE_WATER_PUMP: 'EnableWaterPump',

  PLATE_RECOGNITION_STATE_CHANGED: 'PlateRecognitionStateChanged',
  IS_PLATE_RECOGNITION_ENABLED: 'IsPlateRecognitionEnabled',
  SET_PLATE_RECOGNITION_ENABLED: 'SetPlateRecognitionState',
  IS_ALREADY_SCANNED_ALL_EMPTY_NESTS: 'IsAlreadyScannedAllEmptyNests',
  REGISTER_PLATE_LIB_EMPTY_NESTS: 'RegisterPlateLibAllEmptyNests',
  GET_CURRENT_SCANNED_NEST_IDS: 'GetCurrentScannedNestIds',
  CLEAR_ALL_CURRENT_SCANNED_NESTS_DATA: 'ClearAllCurrentScannedNestsData',
  SCAN_SINGLE_NEST_AND_CACHE_DATA: 'ScanSingleNestAndCacheData',
  REGISTER_CACHED_DETECTION_DATA: 'RegisterCachedDetectionData',
  IS_PLATE_ALREADY_TRAINED: 'IsPlateAlreadyTrained',
  SET_FEEDBACK_FOR_RUNTIME_PLATE_VALIDATION: 'SetFeedbackForRuntimePlateValidation',
  GET_PLATE_TRAINING_STATUS: 'GetPlatesTrainingStatus',
  REMOVE_PLATE_FROM_LIBRARY: 'RemovePlateFromLibrary',
  IS_HUMIDIFIER_CONNECTED: 'IsHumidifierConnected',
  HUMIDIFIER_CONNECTION_CHANGE: 'HumidifierConnectionChange',
  // #endregion instrumentcontrol hub

  // #region userManagement hub
  CREATE_USER: 'CreateUser',
  UPDATE_USER: 'UpdateUser',
  UPDATE_USER_NAME_AND_EMAIL: 'UpdateUserNameAndEmail',
  GET_USERS: 'GetUsers',
  GET_USERS_BY_ROLE_LEVEL: 'GetUsersByRoleLevel',
  DELETE_USERS: 'DeleteUsers',
  CHANGE_PASSWORD: 'ChangePassword',
  LOGIN: 'Login',
  DELETE_USER_WITHOUT_TRANSFER_OWNERSHIP: 'DeleteUserWithoutTransferOwnership',
  DELETE_USER_AND_TRANSFER_OWNERSHIP: 'DeleteUserAndTransferOwnership',
  GET_ROLES: 'GetRoles',
  GET_ROLE_GROUP_RIGHTS_DATA_BY_ROLE_ID: 'GetRoleGroupRightsDataByRoleId',
  IS_AUTO_SAVE_PROTOCOL: 'IsAutoSaveProtocol',
  SET_AUTO_SAVE_PROTOCOL: 'SetAutoSaveProtocol',
  SET_EXPLORER_VIEW_SETTING: 'SetExplorerViewSetting',
  GET_EXPLORER_VIEW_SETTING: 'GetUserExplorerViewSetting',
  // #endregion userManagement hub

  // #region A1 offset
  RESET_DATA_MARKER_POSITION: 'ResetDataMarkerPosition',
  ALIGN_TO_DECK_CADDY_AFTER_SET_MARKER_A1: 'AlignToDeckCaddyAfterSetMarkerA1',
  SET_MARKER_POSITION_AFTER_UPDATE_A1: 'SetMarkerPositionAfterUpdateA1',
  SCAN_YAW_SEQUENCE: 'ScanYawSequence',
  SAFE_AUTO_A1_OFFSET_CALIBRATION: 'SafeAutoA1OffsetCalibration',
  GET_STATUS_AUTO_A1_OFFSET_CALIBRATION: 'GetStatusAutoA1OffsetCalibration',
  // #endregion A1 offset

  // #region tray
  GET_PROTOCOL_BIND_ON_TRAY: 'GetProtocolBindOnTray',
  BIND_PROTOCOL_TO_TRAY: 'BindProtocolToTray',
  // #endregion tray

  // #region runtime
  RUN_PROTOCOL: 'RunProtocol',
  // #endregion runtime

  // #region protocol management
  CREATE_PROTOCOL: 'CreateProtocol',
  UPDATE_PROTOCOL: 'UpdateProtocol',
  DELETE_PROTOCOLS: 'DeleteProtocols',
  GET_PROTOCOLS: 'GetProtocols',
  GET_PROTOCOLS_AND_FOLDERS_BY_FOLDER_ID: 'GetProtocolsAndFoldersByFolderId',
  GET_PROTOCOL_BY_ID: 'GetProtocolById',
  GET_PROTOCOL_BY_ID_AND_USER_ID: 'getProtocolByIdAndUserId',
  DUPLICATE_PROTOCOLS: 'DuplicateProtocols',
  SEND_PROTOCOL: 'SendProtocol',
  SEND_PROTOCOLS_AND_FOLDERS: 'SendProtocolsAndFolders',
  SHARE_UNSHARE_PROTOCOLS_AND_FOLDERS: 'ShareUnshareProtocolsAndFolders',
  CREATE_PROTOCOL_FOLDER: 'CreateProtocolFolder',
  RENAME_PROTOCOL_FOLDER: 'RenameProtocolFolder',
  DELETE_PROTOCOLS_AND_FOLDERS: 'DeleteProtocolsAndFolders',
  DUPLICATE_PROTOCOLS_AND_FOLDERS: 'DuplicateProtocolsAndFolders',
  MOVE_PROTOCOLS_AND_FOLDERS: 'MoveProtocolsAndFolders',
  COPY_PROTOCOLS_AND_FOLDERS: 'CopyProtocolsAndFolders',
  IS_FOLDER_CONTAINS_TESSARA_PROTOCOL: 'IsFolderContainsTessaraProtocol',
  GET_PROTOCOL_FOLDER_DATA_BY_ID: 'GetProtocolFolderDataById',
  GET_USERS_WITH_LICENSE_CHECK: 'GetUsersWithLicenseCheck',
  ADD_FAVORITE_PROTOCOLS: 'AddFavorite',
  REMOVE_FAVORITE_PROTOCOLS: 'RemoveFavorite',
  GET_FAVORITE_PROTOCOLS: 'GetFavorite',
  // #endregion protocol management

  // #region running protocol
  SAVE_RUNNING_PROTOCOL: 'SaveRunningProtocol',
  CLEAR_RUNNING_PROTOCOL: 'ClearRunningProtocol',
  GET_RUNNING_PROTOCOL: 'GetRunningProtocol',
  USER_CONFIRMATION_DIALOG: 'UserConfirmationDialog',
  DELAY_DIALOG: 'DelayDialog',
  // #endregion

  // #region software updater
  UPLOAD_PACKAGE: 'UploadPackage',
  PREPARE_SOFTWARE_UPDATE: 'PrepareSoftwareUpdate',
  FINALIZE_SOFTWARE_UPDATE: 'FinalizeSoftwareUpdate',
  CANCEL_FINALIZE_SOFTWARE_UPDATE: 'CancelFinalizeSoftwareUpdate',
  GET_SOFTWARE_UPDATE_STATUS: 'GetSoftwareUpdateStatus',
  SOFTWARE_UPDATE_PROGRESS: 'SoftwareUpdateProgress',
  PREPARE_SOFTWARE_UPDATE_STARTED: 'PrepareSoftwareUpdateStarted',
  DOWNGRADE_SOFTWARE: 'DowngradeSoftware',
  DOWNGRADE_SOFTWARE_UPDATE: 'DowngradeSoftwareUpdate',
  MULTI_UPLOAD_UPDATE_PACKAGE_COMPLETE: 'MultiUploadPackageComplete',
  MULTI_UPLOAD_UPDATE_PACKAGE_START: 'MultiUploadPackageStart',
  // #endregion

  // #region head channels config
  GET_HEAD_BROKEN_TIPS: 'GetHeadBrokenTips',
  SET_HEAD_BROKEN_TIPS: 'SetHeadBrokenTips',
  // #endregion head channels config

  // #region error reporting
  SAVE_UI_LOG: 'SaveUILog',
  SEND_ERROR: 'SendError',
  // #endregion error reporting

  // #region license
  LICENSE_IMPORT: 'LicenseImport',
  LICENSE_ACTIVATE_TRIAL: 'LicenseActivateTrial',
  LICENSE_ACTIVATE: 'LicenseActivate',
  LICENSE_ACTIVATED: 'LicenseActivated',
  LICENSE_GET_DATA: 'LicenseGetData',
  // #endregion

  // #region simulation
  GET_SIMULATION: 'GetIsSimulationStatus',
  GET_AUTOMATION: 'GetIsAutomationMode',
  // #endregion simulation

  // #region backup and restore data
  PREPARE_BACKUP_START: 'PrepareBackupStart',
  PREPARE_BACKUP_END: 'PrepareBackupEnd',
  PREPARE_RESTORE_START: 'PrepareRestoreStart',
  PREPARE_RESTORE_END: 'PrepareRestoreEnd',
  FINALIZE_RESTORE_START: 'FinalizeRestoreStart',
  LAST_FINALIZE_RESTORE_RES_ON_CONNECTED: 'LastFinalizeRestoreResOnConnected',
  // #endregion
};

export const SignalREventInstrumentManagement = {
  UPDATE_STATUS: 'UpdateStatus',
  REMOVE_STATUS: 'RemoveStatus',
  GET_STATUS: 'GetStatus',
};

export const ApiRouteMap = {
  DOWNLOAD_PROTOCOL: 'DownloadProtocol',
  UPLOAD_PROTOCOL: 'UploadProtocol',
  UPLOAD_PROTOCOL_ZIP: 'UploadProtocolZip',
  CONFIRM_UPLOAD_PROTOCOL_ZIP: 'ConfirmUploadProtocolZip',
  UPLOAD_UPDATE_PACKAGE: 'UploadPackage',
  MULTI_UPLOAD_UPDATE_PACKAGE: 'MultiUploadPackage',
  GET_INSTRUMENT_STATUS: 'status',
  TEST_FLH: 'Test',
  GET_FAST_INFO: 'GetFastInfo',
  DOWNLOAD_DISPENSE_REPORT: 'dispensereport',
  CREATE_LABWARE_DEFINITIONS: 'api/labwaredatabase/addMultiple/true',
  READ_LABWARE_DEFINITIONS: 'api/labwaredatabase/get/true',
  UPDATE_LABWARE_DEFINITION: 'api/labwaredatabase/update/true',
  DELETE_LABWARE_DEFINITIONS: 'api/fastlabware/delete',
  DUPLICATE_LABWARE_DEFINITIONS: 'api/labwaredatabase/duplicate',
  SEND_ERROR: 'supportPackage/sendError',
  PREPARE_DOWNLOAD_LOG_DATE: 'api/ErrorReport/createLog',
  PREPARE_DOWNLOAD_LOG_IDS: 'api/ErrorReport/prepareDownload',
  DOWNLOAD_LOG: 'api/ErrorReport/download',
  GET_LOG_LIST: 'api/ErrorReport/getList',
  READ_DISPENSE_REPORTS: 'api/dispensereport/get',
  UPDATE_DISPENSE_REPORT: 'api/dispensereport/update',
  DELETE_DISPENSE_REPORTS: 'api/dispensereport/delete',
  DOWNLOAD_DISPENSE_REPORTS: 'api/dispensereport/download',
  ELABORATE_LAST_DISPENSE_REPORTS: 'api/dispensereport/elaborate',
  DOWNLOAD_BACKUP_DATA: 'backuprestore/download',
  UPLOAD_RESTORE_DATA: 'backuprestore/multiuploadrestorepkg',
  FINALIZE_UPLOAD_RESTORE_DATA: 'backuprestore/finalizerestorepkg',
  GET_SOFTWARE_VER_AND_UPDATE_INFO: 'SoftwareUpdater/GetSoftwareVerAndUpdateInfo',
  GET_CHECK_ALL_SERVICES_OPERATIONAL: 'api/test/checkalloperational',
};

export const ViewMode = {
  EXPLORER: 'Explorer',
  TRAY_CALIBRATION: 'TrayCalibration',
  LABWARE_MANAGER: 'LabwareManager',
  RETEACH_PLATE: 'ReteachPlate',
  DISPENSE_REPORT_EXPLORER: 'DispenseReportExplorer',
  LOG_LIST: 'LogList',
  PROTOCOL_EDITOR: 'ProtocolEditor',
  USER_MANAGEMENT: 'UserManagement',
  LOGIN: 'Login',
  LOGIN_CONFIRMATION: 'LoginConfirmation',
  SET_TIP: 'SetTip',
  RUNTIME: 'Runtime',
  PLATE_TYPE_EDITOR: 'PlateTypeEditor',
  SERIAL_DILUTION_OLD: 'SerialDilution',
  NORMALIZATION_OLD: 'Normalization',
  ABOUT: 'About',
  SETUP_WIZARD: 'SetupWizard',
  TIPS_PICKUP_CALIBRATION: 'tipsPickupCalibration',
};

export const ProtocolEditorViewMode = {
  SIMPLE_TRANSFER: 'SimpleTransfer',
  SERIAL_DILUTION: 'SerialDilution',
  NORMALIZATION: 'Normalization',
  BROADCAST: 'Broadcast',
  POOLING: 'Pooling',
  MIXING: 'Mixing',
  PICKLIST: 'Picklist',
};

export const Orientation = {
  POTRAIT: 'Potrait',
  LANDSCAPE: 'Landscape',
};

export const WellSurfaceDataShape = {
  CIRCLE: 'Circle',
  RECTANGLE: 'Rectangle',
};

export const CurrentStateEnum = {
  IDLE: 'idle',
  PAUSED: 'paused',
  RUNNING: 'running',
  VALIDATED: 'validated',
};

export const AutoCalibrationControllerState = {
  IDLE: 'Idle',
  RUNNING: 'Running',
  ABORTING: 'AbortRequested',
  PAUSED: 'Paused',
};

export const AutoA1OffsetCalibrationState = {
  NONE: 'none',
  DONE: 'done',
};

export const Feedback = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const FastRobotErrorcode = {
  NoError: 'noError',
  ActuatorFollowingErrorMoving: 'actuatorFollowingErrorMoving',
  ActuatorFollowingErrorIdle: 'actuatorFollowingErrorIdle',
  ActuatorAborted: 'actuatorAborted',
  ActuatorEncoderError: 'actuatorEncoderError',
  ActuatorIllegalPos: 'actuatorIllegalPos',
  ActuatorWaitMotionTimeout: 'actuatorWaitMotionTimeout',
  ActuatorEmergencyStop: 'actuatorEmergencyStop',
  NotReady: 'notReady',
  Busy: 'busy',
  TouchProbeRetractFailed: 'touchProbeRetractFailed',
  TouchProbeExtendFailed: 'touchProbeExtendFailed',
  MissingTray: 'missingTray',
  InvalidTrayID: 'invalidTrayID',
  MismatchedInstalledTrayAndProtocol: 'mismatchedInstalledTrayAndProtocol',
  UnsupportedTray: 'unsupportedTray',
  ActuatorUnexpectedTrigger: 'actuatorUnexpectedTrigger',
  TouchProbeExpanded: 'touchProbeExpanded',
  HardwareNotExist: 'hardwareNotExist',
  TipsNotEnough: 'tipsNotEnough',
  TipsNotEnoughPartially: 'tipsNotEnoughPartially',
  TipsNotEnoughPartiallyYouHaveNoChoice: 'tipsNotEnoughPartiallyYouHaveNoChoice',
  NEED_INSERT_EMPTY_WASTE_CADDY: 'needInsertEmptyWasteCaddy',
  NEED_EMPTY_WASTE_CADDY_AND_REFILL_TIP_CADDY: 'needEmptyWasteCaddyAndRefillTipCaddy',
  WASTE_CADDY_EJECT_POSITION_NOT_AVAILABLE: 'wasteCaddyEjectPositionNotAvailable',
  PICK_TIP_CADDY_COLLIDE_WITH_WASTE_CADDY: 'pickTipCaddyCollideWithWasteCaddy',
  EJECT_TO_CADDY_FALLEN_TIPS_DETECTED: 'ejectToCaddyFallenTipsDetected',
  TIPS_NOT_ENOUGH_PARTIALLY_UNREACHABLE: 'tipsNotEnoughPartiallyUnreachable',
  TrayUncalibrated: 'trayUncalibrated',
  IncorrectState: 'incorrectState',
  ImpossibleLabwarePos: 'impossibleLabwarePos',
  PlatePosSuggestionAvailable: 'platePosSuggestionAvailable',
  TipsNeedArrangement: 'tipsNeedArrangement',
  ActuatorNotReady: 'actuatorNotReady',
  ActuatorAbortedEnterWell: 'actuatorAbortedEnterWell',
  VISION_NOT_CONFIDENT: 'visionNotConfident',
  CADDY_NOT_EXIST: 'caddyNotExist',
  FAILED_TO_CALCULATE_TIPS: 'failedToCalculateTips',
  INVALID_ASPIRATE_DISPENSE_VOLUME_SUM: 'invalidAspirateDispenseVolumeSum',
  UNREACHABLE_TIPS_NEED_MANUAL_ARRAGEMENT: 'unReachableTipsNeedManualArragement',
  UNREACHABLE_TIPS_NEED_REMOVE_DECK_1: 'unReachableTipsNeedRemoveDeck1',
  UNREACHABLE_TIPS_NEED_REMOVE_DECK_1_NOT_ENOUGH_TIPS_DECK_2: 'unReachableTipsNeedRemoveDeck1AndNotEnoughTipDeck2',
  UNREACHABLE_TIPS_NEED_MOVE_CADDY_TO_OTHER_DECK: 'unReachableTipsNeedMoveCaddytoOtherDeck',
  TIPS_REARRANGEMENT_UNSUPPORTED: 'tipsRearrangementUnsupported',
  MISALIGNMENT_TRAY: 'misalignmentTray',
  FALLEN_TIPS_DETECTED: 'fallenTipsDetected',
  STUCK_TIPS_DETECTED: 'stuckTipsDetected',
  SLANTED_TIPS_DETECTED: 'slantedTipsDetected',
  FALLEN_AND_SLANTED_TIPS_DETECTED: 'fallenTipAndSlantedTipDetected',
  TOUCH_PROBE_COLLISION: 'touchProbeCollision',
  INVALID_UPDATE_PACKAGE: 'invalidUpdatePackage',
  FAILED_TO_UPLOAD_UPDATE_PACKAGE: 'failedToUploadUpdatePackage',
  OLDER_UPDATE_PACKAGE: 'olderUpdatePackage',
  UNKNOWN_PLATE_ID: 'unknownPlateID',
  MIRROR_DIRTY: 'mirrorDirty',
  MIRROR_NOT_FOUND: 'mirrorNotFound',
  HEAD_BROKEN_TIPS: 'impossibleLabwarePosDueToBrokenChannel',
  NO_TRAY_ID_FOUND: 'visionNoTrayIdFound',
  TRAY_ID_POSITION_NOT_FOUND: 'visionTrayIdPositionNotFound',
  CALIBRATION_EXCEED_THRESHOLD: 'calibrationExceedThreshold',
  UPDATE_INTERNAL_ERROR: 'updateInternalError',
  A1_OFFSET_UNFIT: 'a1OffsetUnfit',
  INVALID_LABWARE: 'invalidLabware',
  CONSOLIDATE_TIPS_TASK_CONTAINS_INVALID_CADDIES_COUNT: 'consolidateTipsTaskContainsInvalidCaddiesCount',
  CONSOLIDATE_TIPS_TASK_NO_CADDY_1: 'consolidateTipsTaskNoCaddy1',
  CONSOLIDATE_TIPS_TASK_NO_CADDY_2: 'consolidateTipsTaskNoCaddy2',
  EMPTY_CADDY_SOURCE: 'emptyCaddySource',
  FULL_CADDY_DESTINATION: 'fullCaddyDestination',
  LOAD_CELL_VALUE_NO_CHANGE: 'loadcellValueNoChange', // Recoverable load cell error
  LOAD_CELL_DRIVER_FAULT: 'loadcellDriverFault', // unrecoverable load cell error
  LOAD_CELL_READ_TIMEOUT: 'loadcellReadTimeout',
  LABWARE_NOT_DETECTED: 'labwareNotDetected',
  FAILED_TO_DETECT_WATER: 'failedToDetectWater',

  // #region vision
  VISION_MULTIPLE_TRAY_ID_FOUND: 'visionMultipleTrayIdFound',
  FAILED_TO_COMMUNICATE_WITH_RASPI0: 'failedToCommunicateWithRaspi0',
  BARCODE_SCAN_FAILED: 'barcodeScanFailed',
  BARCODE_NOT_UNIQUE: 'barcodesNotUnique',
  CORAL_NOT_CONNECTED: 'coralNotConnected',
  CAMERA_NOT_CONNECTED: 'cameraNotConnected',
  SSH_CONNECTION_FAILED: 'sshConnectionFailed',
  MIRROR_FIDUCIAL_NOT_FOUND: 'mirrorFiducialNotFound',
  VISION_CALIBRATION_FAILED: 'visionCalibrationFailed',
  INCOMPATIBLE_VISION_VERSION: 'incompatibleVisionVersion',
  CORAL_AND_CAMERA_NOT_CONNECTED: 'coralAndCameraNotConnected',
  WRONG_IMAGE_SHAPE: 'wrongImageShape',
  WRONG_DETECTION_BOX_DIMENSION: 'wrongDetectionBoxDimension',
  WRONG_IMAGE_DETECTION: 'wrongImageDetection',
  PREDICT_IMAGE_TIMEOUT: 'predictImageTimeOut',
  PREDICT_IMAGE_INVOKE_FAILED: 'predictImageInvokeFailed',
  DESTINATION_HOST_UNREACHABLE: 'destinationHostUnreachable',
  PI0_SERVICE_INACTIVE: 'pi0ServiceInactive',
  PI0_SERVICE_FAST_VISION_INACTIVE: 'pi0ServiceFastVisionInactive',
  PI0_SERVICE_SPI2VCAN_INACTIVE: 'pi0ServiceSpi2vcanInactive',
  CAN_COMMUNICATION_ISSUE: 'canCommunicationIssue',
  FILE_MODEL_DOESNT_EXIST: 'fileModelDoesntExist',
  FILE_MODEL_CORRUPTED: 'fileModelCorrupted',
  WRONG_MODEL_IS_USED: 'wrongModelIsUsed',
  INVALID_CONFIG_SELECTOR: 'invalidConfigSelector',
  VISION_SERVICE_CRASHES: 'visionServiceCrashes',
  CADDY_NOT_FOUND: 'caddyNotFound',
  WRONG_PLATE_TYPE: 'wrongPlateType',
  IN_CORAL_LESS_MODE: 'inCoralLessModeCantExecuteThisCommand',
  MISS_ALIGN_YAW: 'missAlignYaw',
  MISS_ALIGN_ROLL: 'missAlignRoll',
  MISS_ALIGN_PITCH: 'missAlignPitch',
  CADDY_TYPE_MISMATCHED: 'caddyTypeMismatched',
  // #endregion vision

  // #region license
  NO_LICENSE_ACTIVATED: 'noLicenseActivated',
  INVALID_LICENSE_FILE: 'invalidLicenseFile',
  INVALID_LICENSE_SERIAL_NUMBER: 'invalidLicenseSerialNumber',
  INVALID_LICENSE_PRODUCT_LICENSE: 'invalidProductLicense',
  INVALID_LICENSE_MAINTENANCE_EXPIRED: 'invalidLicenseMaintenanceExpired',
  INVALID_LICENSE_EXPIRED: 'invalidLicenseExpired',
  // #endregion license

  // #region picklist & v2 csv import
  TOO_MANY_LABWARES: 'tooManyLabwares',
  UNSUPPORTED_LABWARE: 'unsupportedLabware',
  UNSUPPORTED_VOLUME_TRANSFER: 'unsupportedVolumeTransfer',
  FAILED_TO_PARSE: 'failedToParse',
  INVALID_CONTENT: 'invalidContent',
  REQUIRED_BARCODE_NOT_FOUND: 'requiredBarcodeNotFound',
  PLATE_POS_SUGGESTION_AVAILABLE: 'platePosSuggestionAvailable',
  INVALID_WELL_TARGET: 'invalidWellTarget',

  INVALID_CSV_COLUMN: 'invalidCsvColumn',
  INVALID_CSV_ROW: 'invalidCsvRow',
  INVALID_CSV_DATA_TYPE: 'invalidCsvDataType',
  CSV_MISSING_REQUIRED_FIELD: 'csvMissingRequiredField',
  INVALID_CSV_IMPORT_MIXING_VOLUME: 'invalidCsvImportMixingVolume',
  // #endregion picklist & v2 csv import

  // #region tips pickup calibration
  CADDY_JIG_SURFACE_NOT_DETECTED: 'caddyJigSurfaceNotDetected',
  COLLISION_TRIGGERED_IN_FIRST_SEQUENCE: 'collisionTriggeredInFirstSequence',
  MAX_TUNING_SEQUENCE_COUNT: 'maxTuningSequenceCount',
  UNWANTED_COLLISION_TRIGGERED: 'unwantedCollisionTriggered',
  INVALID_VERTICAL_TRIGGERED_POSITION: 'invalidVerticalTriggeredPosition',
  // #endregion tips pickup calibration

  // #region backup and restore data
  FAILED_TO_UPLOAD_RESTORE_PKG: 'failedToUploadRestorePkg',
  INVALID_RESTORE_PACKAGE: 'invalidRestorePackage',
  BACKUP_INTERNAL_ERROR: 'backupInternalError',
  RESTORE_INTERNAL_ERROR: 'restoreInternalError',
  FAILED_TO_DOWNLOAD_BACKUP_ZIP: 'failedToDownloadBackupZip',
  MISMATCH_SOFTWARE_VERSION: 'mismatchSoftwareVersion',
  MISMATCH_INSTRUMENT_SERIAL_NUMBER_VERSION: 'mismatchInstrumentSerNum',
  MISMATCH_SOFTWARE_AND_INSTRUMENT_VERSION: 'mismatchSoftwareAndInstrument',
  // #endregion backup and restore data
};

export const InstrumentStatuses = {
  NONE: 'none',
  BUSY: 'busy',
  ERROR: 'error',
  CARRY_TIP: 'carryTip',
  TRAY_NOT_EXIST: 'trayNotExist',
  TRAY_ID_INVALID: 'trayIDInvalid',
  TRAY_UNCALIBRATED: 'trayUncalibrated',
  CALIBRATION_PROBE_EXPANDED: 'calibrationProbeExpanded',
};

export const InfoBoxStatus = {
  INFO: 'info',
  ERROR: 'error',
};

export const GetAllMotorStatusMotorErrorStatus = ['folErrorIdle', 'folErrorMoving', 'encoderError'];

export const MotorName = ['Horizontal Carrier', 'Tray', 'Vertical Carrier', 'Plunger', 'Plunger Clamp', 'Tip Clamp'];

export const DragDropType = {
  DECK_LABWARE: 'DECK_LABWARE',
  LIST_LABWARE: 'LIST_LABWARE',
  TASK_CARD: 'TASK_CARD',
  TASK_ITEM: 'TASK_ITEM',
  TRANSFORM_SELECTION: 'TRANSFORM_SELECTION',
  CARD_GROUP: 'CARD_GROUP',
  PROTOCOL_EXPLORER_ITEM: 'PROTOCOL_EXPLORER_ITEM',
};

export const CardType = {
  SIMPLE_TRANSFER: 'Simple Transfer',
  SERIAL_DILUTION: 'Serial Dilution',
  NORMALIZATION: 'Normalization',
  DELAY: 'Delay',
  CONFIRMATION: 'Confirmation',
  BROADCAST: 'Broadcast',
  POOLING: 'Pooling',
  MIXING: 'Mixing',
  AIR_GAP: 'AirGap',
  CONSOLIDATE_TIPS: 'ConsolidateTips',
  ENABLE_HUMIDIFIER: 'EnableHumidifier',
};

export const SubCardType = {
  PICKLIST: 'Picklist',
};

export const CardInvalidType = {
  PICK_TIP: 'PickTip',
  PICK_TIP_DOES_NOT_EXIST: 'PickTipDoesNotExist',
  EJECT_TIP: 'EjectTip',
  EJECT_TIP_DOES_NOT_EXIST: 'EjectTipDoesNotExist',
  ASPIRATE: 'Aspirate',
  DISPENSE: 'Dispense',
  INSUFFICIENT_ASPIRATE_VOLUME: 'InsufficientAspirateVolume',
  OVER_ASPIRATE: 'OverAspirate',
  ZERO_ASPIRATE: 'ZeroAspirate',
  AIR_GAP_ORDER: 'AirGapOrder',
  AIR_GAP_VOLUME: 'AirGapVolume',
  REDEFINE: 'Redefine',
  UNFINISHED: 'UNFINISHED',
  LABWARE_NOT_FOUND: 'labwareNotFound',
  LIQUID_REMAINS_IN_TIP_FOR_MIXING: 'liquidRemainsInTipForMixing',
  MIXING_WITHOUT_PICK_TIP: 'mixingWithoutPickTip',
};

export const TaskType = {
  PICK_TIP: 'PickTip',
  ASPIRATE: 'Aspirate',
  DISPENSE: 'Dispense',
  EJECT_TIP: 'EjectTip',
  DELAY: 'Delay',
  USER_CONFIRMATION: 'UserConfirmation',
  USER_CONFIRMATION_EJECT: 'UserConfirmationEject',
  INSERT_TASK: 'InsertTask',
  MIXING: 'Mixing',
  AIR_GAP: 'AirGap',
  CONSOLIDATE_TIPS: 'ConsolidateTips',
  ENABLE_HUMIDIFIER: 'EnableHumidifier',
};

export const TaskDelayUnit = {
  SECOND: 'second(s)',
  MINUTE: 'minute(s)',
};

export const TipChannelType = {
  TIP_CHANNEL_CUSTOM: 'tipChannelCustom',
  TIP_CHANNEL_96: 'tipChannel96',
  TIP_CHANNEL_12: 'tipChannel12',
  TIP_CHANNEL_8: 'tipChannel8',
  TIP_CHANNEL_1: 'tipChannel1',
};

export const ArrowDirectionType = {
  LEFT: 'left',
  RIGHT: 'right',
};

export const ArrowLineType = {
  STRAIGHT: 'straight',
  CURVED: 'curved',
  BOW: 'bow',
  EDGED: 'edged',
};

export const WellCount = {
  WELL_1: 1,
  WELL_6: 6,
  WELL_8: 8,
  WELL_12: 12,
  WELL_24: 24,
  WELL_48: 48,
  WELL_96: 96,
  WELL_384: 384,
  WELL_1536: 1536,
  WELL_IFC_192_24: 264,
  WELL_IFC_96_96: 192, // waiting BE for actual data
  WELL_IFC_48_48: 96, // waiting BE for actual data
  WELL_SPEAR_BIO: 29, // waiting BE for actual data
};

export const WellCountLabel = {
  WELL_IFC_192_24: 'IFC 192.24',
};

export const PlateType = {
  MICROPLATE: 'Microplate',
  IFC: 'IFC',
  SPEAR_BIO: 'SpearBio',
};

export const IFCPlateVariant = {
  IFC192: 192,
  IFC96: 96,
  IFC48: 48,
};

export const DefaultWellValue = {
  WELL_1: {rowPitch: 0, columnPitch: 0},
  WELL_6: {rowPitch: 36, columnPitch: 36},
  WELL_8: {rowPitch: 9, columnPitch: 0},
  WELL_12: {rowPitch: 0, columnPitch: 9},
  WELL_24: {rowPitch: 19.3, columnPitch: 19.3},
  WELL_48: {rowPitch: 13, columnPitch: 13},
  WELL_96: {rowPitch: 9, columnPitch: 9},
  WELL_384: {rowPitch: 4.5, columnPitch: 4.5},
  WELL_1536: {rowPitch: 2.25, columnPitch: 2.25},
  WELL_IFC_192_24: {rowPitch: 4.5, columnPitch: 4.5, columnPitchAssaySample: 6.5},
  WELL_IFC_96_96: {rowPitch: 4.5, columnPitch: 4.5},
  WELL_IFC_48_48: {rowPitch: 4.5, columnPitch: 4.5},
};

export const WellBottomProfile = {
  FLAT: 'Flat',
  ROUNDED: 'U',
  CONYCAL: 'V',
};

export const LabwareWellCount = {
  LABWARE_1: 1,
  LABWARE_8: 8,
  LABWARE_12: 12,
  LABWARE_96: 96,
  LABWARE_384: 384,
};

export const MotorErrorStatusEnum = ['folErrorIdle', 'folErrorMoving', 'encoderError'];

export const RuntimeMode = {
  IDLE: 'IDLE',
  RUNNING: 'RUNNING',
  RUNNING_CONSOLIDATE_TIPS: 'RUNNING_CONSOLIDATE_TIPS',
  ABORTED: 'ABORTED',
  ERROR_ABORT: 'ERROR_ABORT',
  ERROR_ABORT_MOTOR_SKIP: 'ERROR_ABORT_MOTOR_SKIP',
  ERROR_ABORT_MOTOR_COLLISION_SKIP: 'ERROR_ABORT_MOTOR_COLLISION_SKIP',
  ERROR_MISSING_TRAY: 'ERROR_MISSING_TRAY',
  FINISH: 'FINISH',
  PAUSING: 'PAUSING',
  PAUSED: 'PAUSED',
  RUNTIME_PREPARATION: 'PREPARATION',
  ABORTING: 'ABORTING',
};

export const RuntimeType = {
  NORMAL: 'NORMAL',
  TESSARA_SUPER_USER: 'TESSARA_SUPER_USER',
  TESSARA_REGULAR_USER: 'TESSARA_REGULAR_USER',
  CONSOLIDATE_TIPS: 'CONSOLIDATE_TIPS',
};

export const RuntimeNotificationType = {
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
  ERROR: 'error',
};

export const LastExecEnum = {
  NONE: 'none',
  SCAN_TIPS: 'scanTips',
  ALIGN_TO_PICK_TIP: 'alignToPickTip',
  PICK_TIP: 'pickTip',
  ALIGN_TO_ASPIRATE: 'alignToAspirate',
  ALIGN_TO_ASPIRATE_CARRY_LIQUID: 'alignToAspirateCarryLiquid',
  ALIGN_TO_ASPIRATE_CARRY_LIQUIDS: 'alignToAspirateCarryLiquids',
  ASPIRATE: 'aspirate',
  ASPIRATE_CARRY_LIQUID: 'aspirateCarryLiquid',
  ALIGN_TO_DISPENSE: 'alignToDispense',
  ALIGN_TO_DISPENSE_CARRY_LIQUIDS: 'alignToDispenseCarryLiquids',
  DISPENSE_LIQUIDS: 'dispenseLiquids',
  EJECT_TIP: 'ejectTip',
  ALIGN_TO_EJECT_TIP: 'alignToEjectTip',
  ALIGN_TO_ASPIRATE_REUSE_TIP: 'alignToAspirateReuseTip',
  ALIGN_TO_RETURN_TIP: 'alignToReturnTip',
  RETURN_TIP: 'returnTip',
  DISPENSE_LIQUID: 'dispenseLiquid',
  ENTER_WELL_BEFORE_ASPIRATE: 'enterWellBeforeAspirate',
  ALIGN_CHECK: 'alignCheck',
  SCAN_STUCK_TIPS: 'scanStuckTips',
  USER_CONFIRMATION_CARRY_TIP: 'userConfirmationCarryTip',
  USER_CONFIRMATION: 'userConfirmation',
  MIXING: 'mixingTask',
  SCAN_BARCODE: 'scanBarcode',

  CONSOLIDATE_TIPS: 'consolidateTips',
  CONSOLIDATE_TIPS_EMPTY_SOURCE: 'consolidateTipsEmptySourceCaddy',
  CONSOLIDATE_TIPS_FULL_DESTINATION: 'consolidateTipsFullDestinationCaddy',
  MIXING_BEFORE_ASPIRATE: 'mixingBeforeAspirate',
  MIXING_AFTER_DISPENSE: 'mixingAfterDispense',
};

export const ExecutionStatus = {
  NONE: 'none',
  EXECUTING: 'executing',
  EXECUTED: 'executed',
};

export const Dilution = {
  ROW: 'row',
  COLUMN: 'column',
  QUADRANT: 'Quadrant',
};

export const DispensePattern = {
  ALONG_ROW: 'ALONG_ROW',
  ALONG_COLUMN: 'ALONG_COLUMN',
  PATTERN_384_1: 'PATTERN_384_1',
  PATTERN_384_2: 'PATTERN_384_2',
  PATTERN_384_3: 'PATTERN_384_3',
  PATTERN_384_4: 'PATTERN_384_4',
  SERIAL_DILUTION_1: 'SERIAL_DILUTION_1',
  SERIAL_DILUTION_2: 'SERIAL_DILUTION_2',
  SERIAL_DILUTION_3: 'SERIAL_DILUTION_3',
  SERIAL_DILUTION_4: 'SERIAL_DILUTION_4',
};

export const DispenseTaskStatus = {
  SUCCEEDED: 'succeeded',
  PAUSED: 'paused',
  CANCELLED: 'cancelled',
};

// dispense report download page size option
export const PageSizes = [
  {
    name: 'Letter (8.5” x 11”)',
    value: 'LETTER',
  },
  {
    name: 'Legal (8.5” x 14”)',
    value: 'LEGAL',
  },
  {
    name: 'Folio (8.5” x 13”)',
    value: 'FOLIO',
  },
  {
    name: 'A4 (8.27” x 11.69”)',
    value: 'A4',
  },
  {
    name: 'A3 (11.69” x 16.5”)',
    value: 'A3',
  },
];

export const WellIncrementPattern = {
  ORDER_BY_ROW: 'ORDER_BY_ROW',
  ORDER_BY_COLUMN: 'ORDER_BY_COLUMN',
};

export const NormalizationPreviewWellStatus = {
  NORMAL: 'NORMAL',
  INVALID: 'INVALID',
  SKIPPED: 'SKIPPED',
  UNUSED: 'UNUSED',
  INVALID_INPUT: 'INVALID_INPUT',
};

export const ExplorerViewMode = {
  THUMBNAIL: 1,
  LIST: 2,
  DETAIL: 3,
};

export const UserRole = {
  0: 'Service',
  1: 'Administrator',
  2: 'User',
  3: 'Operator',
  4: 'Tessara',
};

export const UserRoleLevel = {
  SERVICE: 0,
  ADMINISTRATOR: 1,
  USER: 2,
  OPERATOR: 3,
  TESSARA_SUPER_USER: 4,
};

export const ServiceResponseCode = {
  OK: 0,
  REACH_FOLDER_LEVEL_LIMIT: 121,
  NOT_VALID_CSV: 122,
  PROTOCOL_NAME_MAX_CHARACTERS_EXCEEDED: 124,
  LABWARE_NOT_FOUND: 125,
  UNABLE_TO_SYNC_LABWARE: 126,
  NOT_VALID_FILE: 127,
  UNAUTH_ACTION_BECAUSE_NOT_TESSARA: 128,
  UNAUTH_FOLDER_ACTION_BECAUSE_NOT_TESSARA: 129,
  FOLDER_TARGET_AND_DESTINATION_ARE_SAME: 133,
  ZIP_FILE_IMPORT_NOT_ENOUGH_PRIVILEGE: -854,
  PROTOCOL_NOT_FOUND: 102,
  MAX_UPLOAD_FILE_SIZE_REACHED: -855,
};

export const ServiceFastErrorcode = {
  UNKNOWN_PLATE_ID: -813,
  MISMATCH_PLATE_DEFINITION_AND_WELL_TARGET: -810,
};

export const SetTrayModalType = {
  TRAY_CALIBRATION: 0,
  PROTOCOL_EDITOR: 1,
  PLATE_TYPE_EDITOR: 2,
};

export const SerialDilutionStep = {
  SERIAL_DILUTION_SETTINGS: -1,
  SET_DILUENT_SOURCE: 1,
  SET_SAMPLE_SOURCE: 2,
  SET_SAMPLE_TARGET: 3,
  SET_DILUENT_TARGET: 4,
};

export const SerialDilutionTaskType = {
  SAMPLE_PREPARATION: 'SamplePreparation',
  DILUENT_PREPARATION: 'DiluentPreparation',
  DILUTION: 'Dilution',
};

export const SDVolumePropKeyToStepEnum = {
  diluentVolume: SerialDilutionStep.SET_DILUENT_SOURCE,
  sampleVolumeAliquot: SerialDilutionStep.SET_SAMPLE_SOURCE,
  aliquotVolume: SerialDilutionStep.SET_SAMPLE_TARGET,
  sampleVolume: SerialDilutionStep.SET_SAMPLE_SOURCE,
  stepSampleVolume: SerialDilutionStep.SET_DILUENT_TARGET,
  stepDiluentVolume: SerialDilutionStep.SET_DILUENT_TARGET,
};

export const SDVolumePropertyKeyEnum = {
  DILUENT_VOLUME: 'diluentVolume',
  SAMPLE_VOLUME: 'sampleVolume',
  SAMPLE_ALIQUOT_VOLUME: 'sampleVolumeAliquot',
  ALIQUOT_VOLUME: 'aliquotVolume',
  STEP_SAMPLE_VOLUME: 'stepSampleVolume',
  STEP_DILUENT_VOLUME: 'stepDiluentVolume',
  RATIO: 'ratio',
};

export const UpdateState = {
  IDLE: 'idle',
  UPLOADED: 'uploaded',
  PREPARING: 'preparing',
  PREPARED: 'prepared',
};

export const LicenseStatus = {
  NO_LICENSE: 'NoLicense',
  ERROR: 'Error',
  TRIAL: 'Trial',
  TRIAL_EXPIRED: 'TrialExpired',
  TEMPORARY: 'Temporary',
  TEMPORARY_EXPIRED: 'TemporaryExpired',
  PERMANENT: 'Permanent',
  PERMANENT_EXPIRED: 'PermanentExpired',
};

export const SWIPING_DIRECTION_Y = {
  UP: 'UP',
  DOWN: 'DOWN',
};

export const SWIPING_DIRECTION_X = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

export const WELL_HOVER_TYPE = {
  TEXT: 'TEXT',
  INDEX_COLOR: 'INDEX_COLOR',
  BOTH: 'BOTH',
  NOTHING: 'NOTHING',
};

export const WELL_HOVER_INDEX_COLOR_POSITION = {
  BOTH: 'BOTH',
  LEFT: 'LEFT',
  TOP: 'TOP',
  NOTHING: 'NOTHING',
};

export const PipettingParameterFieldKey = {
  TIP_POSITION: 'tipPosition',
  TIP_POSITION_X_OFFSET: 'tipXPositionOffset',
  TIP_POSITION_Y_OFFSET: 'tipYPositionOffset',
  MIXING_POSITION: 'mixingPosition',
  ENABLE_MIXING: 'enableMixing',
  MIXING_CYCLE: 'mixingCycle',
  MIXING_VOLUME: 'mixingVolume',
  SPEED: 'speed',
  RETRACT_SPEED: 'retractSpeed',
  MIXING_SPEED: 'mixingSpeed',
  PRECISION_DISPENSE: 'precisionDispense',
  VOLUME: 'volume',
  TIP_TOUCH_OFF: 'tipTouchOff',
  TIP_TOUCH_OFF_DELAY: 'tipTouchOffDelay',
  TIP_TOUCH_OFF_HEIGHT: 'tipTouchOffHeight',
  TIP_TOUCH_OFF_DIRECTION_X: 'tipTouchOffDirectionX',
  TIP_TOUCH_OFF_DIRECTION_Y: 'tipTouchOffDirectionY',
  DISPENSE_AT_WELL_SIDE: 'dispenseAtWellSide',
  MIXING_POSITION_ASPIRATE: 'mixingPositionAspirate',
  MIXING_POSITION_DISPENSE: 'mixingPositionDispense',
  MIXING_POSITION_ASPIRATE_AND_DISPENSE: 'mixingPositionAspirateAndDispense',
};

export const NormalizationStep = {
  SET_SAMPLE_LABWARE: 1,
  SET_DILUENT_LABWARE: 2,
  UPLOAD_AND_MANAGE_CSV_FILE: 3,
  SET_TARGET_CONCENTRATION: 4,
};

export const PLATE_TYPE = {
  PLATE_1: 'oneWell',
  PLATE_8: 'eightWell',
  PLATE_12: 'twelveWell',
  PLATE_96: 'ninetySix',
  PLATE_384: 'threeEightyFour',
};

export const TransformSelectionType = {
  ONE_DIMENSION: 'ONE_DIMENSION',
  TWO_DIMENSION: 'TWO_DIMENSION',
};

export const TransformSelectionPattern = {
  ROW: 'ROW',
  COLUMN: 'COLUMN',
};

export const BarcodeStatus = {
  VALID: 'VALID',
  UNKNOWN: 'UNKNOWN',
  UNIDENTIFIED: 'UNIDENTIFIED',
};

export const PoolingStep = {
  SET_SOURCE: 1,
  SET_VOLUME: 2,
  SET_DESTINATION: 3,
};

export const KeyboardKey = {
  SHIFT: 16,
  CTRL: 17,
  DELETE: 46,
  Y: 89,
  Z: 90,
  D: 68,
  G: 71,
};

export const dispenseReportHeader = [
  'destinationPlateBarcode',
  'destinationPlateName',
  'destinationWell',
  'sourcePlateBarcode',
  'sourcePlateName',
  'sourceWell',
  'transferVolume',
  'number',
  'tips',
  'status',
  'errorCode',
  'start',
  'end',
  'humidity',
  'temperature',
  'isHumidifierDoorOpened',
  'notes',
];

export const IFC192Index = {
  INDEX_1: 1,
  INDEX_2: 2,
  INDEX_3: 3,
  INDEX_4: 4,
  INDEX_5: 5,
  INDEX_6: 6,
  INDEX_7: 7,
  INDEX_8: 8,
  INDEX_9: 9,
  INDEX_10: 10,
  INDEX_11: 11,
  INDEX_12: 12,
};
export const IFC96Index = {
  INDEX_1: 1,
  INDEX_2: 2,
};

export const IFC48Index = {
  INDEX_1: 1,
  INDEX_2: 2,
};

export const SpearBioPlateIndex = {
  INDEX_0: 0,
  INDEX_1: 1,
  INDEX_2: 2,
  INDEX_3: 3,
  INDEX_4: 4,
  INDEX_5: 5,
  INDEX_6: 6,
  INDEX_7: 7,
  INDEX_8: 8,
  INDEX_9: 9,
  INDEX_10: 10,
  INDEX_11: 11,
};

export const LabwareSectionType = {
  TROUGH: 'trough',
  WELL: 'mixWell',
  DIVIDER: 'divider',
};

export const IFCSectionName = {
  192.24: {
    1: 'Sample Inlet 1',
    2: 'Sample Inlet 2',
    3: 'Assay Inlet 1',
    4: 'Assay Inlet 2',
    5: 'P1',
    6: 'P2',
    7: 'P3',
    8: 'P4',
    9: 'Trough 1',
    10: 'Trough 2',
    11: 'Trough 3',
    12: 'Trough 4',
  },
  96.96: {
    1: 'Assay Inlet',
    2: 'Sample Inlet',
  },
  48.48: {
    1: 'Assay Inlet',
    2: 'Sample Inlet',
  },
};

export const ModalType = {
  INCOMPATIBLE_VISION_VERSION: 'IncompatibleVisionVersionModal',
  MISSING_TRAY_ERROR: 'missingTrayError',
  NO_TRAY_ID_FOUND_ERROR: 'noTrayIdFoundError',
  RETURN_TIPS_CONFIRMATION: 'returnTipsConfirmation',
  BACKUP_AND_RESTORE_DATA: 'backupAndRestoreData',
  DOWNLOAD_BACKUP_DATA_FAILED: 'downloadBackupDataFailed',
  PLATE_RECOGNITION: 'plateRecognition',
  INVALID_PLATE_RECOGNITION: 'invalidPlateRecognition',
  IDLE_HUMIDITY: 'idleHumidity',
  HUMIDIFIER_DISCONNECTED: 'humidifierDisconnected',
  CADDY_DETECTION: 'caddyDetection',
  CANNOT_USE_THIS_FEATURE: 'cannotUseThisFeature',
  INSTRUMENT_NON_OPERATIONAL: 'instrumentNonOperational',
};

export const ModalSize = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
  EXTRA_LARGE: 'xl',
};

export const CommonButtonLabel = {
  GOT_IT: 'common.modal.action.gotIt',
  CONFIRM: 'common.modal.action.confirm',
  CONTINUE: 'common.modal.action.continue',
  RETRY: 'common.modal.action.retry',
  RECOVER: 'common.modal.action.recover',

  CLOSE: 'common.modal.action.close',
  CANCEL: 'common.modal.action.cancel',
  ABORT: 'common.modal.action.abort',
  ABORT_PROTOCOL: 'common.modal.action.abortProtocol',
  IGNORE: 'common.modal.action.ignore',
};

export const TrayText = {
  NORMAL_CADDY: 'Single Caddy',
  DOUBLE_CADDY: 'Dual Caddy',
  HIGH_VOLUME_CADDY: 'High Volume Caddy',
};

export const TrayType = {
  NORMAL_CADDY: 'normal',
  DOUBLE_CADDY: 'doubleCaddy',
  HIGH_VOLUME_CADDY: 'highVolume',
};

export const TrayTypeKey = {
  normal: 1,
  doubleCaddy: 2,
  highVolume: 3,
};

export const TipLifetimeThreshold = {
  NORMAL_TIP: 650,
  HIGH_VOLUME_TIP: 2500,
};

export const FastRobotStatusCode = {
  RUNNING: 0,
  PAUSED: 1,
  IDLE: 2,
  REQUIRE_USER_ATTENTION: 3,
  ABORT_REQUESTED: 4,
  ERROR_OCCURED: 5,
};

export const ExplorerContentTypes = {
  FOLDER: 'folder',
  PROTOCOL: 'protocol',
  ITEM: 'item',
};

export const ClipboardEventType = {
  CUT: 'CUT',
  COPY: 'COPY',
};

export const MappedLabwareAction = {
  NO_ACTION: 0,
  USE_EXISTING: 1,
  USE_IMPORTED: 2,
  USE_REPLACE: 3,
};

export const NormalizationType = {
  FIXED_SAMPLE_VOLUME: 'fixedSampleVolume',
  FIXED_DILUENT_VOLUME: 'fixedDiluentVolume',
};

export const RestAPIMethod = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
};

export const LabwareDatabaseAPI = {
  GET_FAVORITE_LABWARE: {
    method: RestAPIMethod.GET,
    route: 'api/fastlabware/getFavorite',
  },
  ADD_LABWARE_TO_FAVORITE: {
    method: RestAPIMethod.POST,
    route: 'api/fastlabware/addFavorite',
  },
  REMOVE_LABWARE_FROM_FAVORITE: {
    method: RestAPIMethod.POST,
    route: 'api/fastlabware/removeFavorite',
  },
};

export const HostRepositoryStateName = {
  AUTHORING: 'urlAuthoringLocation',
  LABWARE_DEFINITION: 'urlLabwareDefinitionRepository',
  INSTRUMENT_CONTROL: 'urlInstrumentControlLocation',
};

export const ImpossibleConsolidateTipsType = {
  INSUFFICIENT_TIPS_CADDY_1: 'INSUFFICIENT_TIPS_CADDY_1',
  INSUFFICIENT_SPACE_CADDY_2: 'INSUFFICIENT_SPACE_CADDY_2',
};

export const MissingTrayOngoingProcess = {
  TRAY_CALIBRATION: 'trayCalibration',
  PLATE_TYPE_EDITOR: 'plateTypeEditor',
  SETUP_WIZARD: 'setupWizard',
  GENERAL: 'general',
};

export const VirtualTrayModalType = {
  DELETE_CONFIRMATION: 'deleteConfirmation',
};

export const ManualReteachTipsStatus = {
  PUT_TO_CADDY: 0,
  PUT_TO_WASTE_BIN: 1,
};

export const DirectionType = {
  DIRECTION_X: 'x',
  DIRECTION_Y: 'y',
  DIRECTION_Z: 'z',
};

export const SortDirectionType = {
  ASC: 'asc',
  DESC: 'desc',
};

export const TipCaddyLocationType = {
  TIP_WASTE_CADDY: 1,
  TIP_PICK_CADDY: 2,
};

export const GENERAL_TRAY_CADDY_LOCATIONS = [2];
export const DUAL_CADDY_TRAY_CADDY_LOCATIONS = [1, 2];

export const CSVImportPlateColumnPreference = {
  PLATE_NAME: 'plateName',
  PLATE_BARCODE: 'plateBarcode',
};

export const CSVModalStep = {
  FILE_UPLOAD: 'FILE_UPLOAD',
  PLATE_COLUMN_PREFERENCE: 'PLATE_COLUMN_PREFERENCE',
  INVALID_CSV: 'INVALID_CSV',
};

export const CSVImportTemplateColumns = [
  'PlateSource',
  'SourceWell',
  'PlateDestination',
  'DestinationWell',
  'TransferVolume',
  'NewTip',
  'CsvCardType',
  'DelayDuration',
  'Message',
  'EjectTray',
  'MixingCycle',
  'MixingVolume',
];

export const SwipeSelectionDirection = {
  WHOLE_ROW: 'row',
  WHOLE_COLUMN: 'column',
  STAMPING: 'stamping',
  ALL: 'all',
};

export const FileType = {
  DB: {
    mime: 'application/db',
    ext: '.db',
  },
  CSV: {
    mime: 'text/csv',
    ext: '.csv',
  },
  I00: {
    mime: 'application/i00',
    ext: '.i00',
  },
  HEX: {
    mime: 'application/hex',
    ext: '.hex',
  },
  PNG: {
    mime: 'image/png',
    ext: '.png',
  },
  ZIP: {
    mime: 'application/zip',
    ext: '.zip',
  },
};

export const SignalRBackupAndRestoreEvent = {
  PREPARE_BACKUP: 'PrepareBackup',
  EXECUTE_RESTORE: 'ExecuteRestore',
  GET_BACKUP_RESTORE_STATUS: 'GetBackupRestoreStatus',
  GET_RESTORE_RESULT: 'GetFinalizeRestoreRes',
  RESET_BACKUP_RESTORE_STATUS: 'ResetBackupRestoreStatus',
};

export const BackupAndRestoreState = {
  IDLE: 'idle',
  PREPARING_BACKUP: 'preparingBackup',
  PREPARED_BACKUP: 'preparedBackup',
  UPLOADING_RESTORE_PKG: 'uploadingRestorePkg',
  FINALIZING_UPLOAD_PKG: 'finalizingUploadPkg',
  UPLOADED_RESTORE_PKG: 'uploadedRestorePkg',
  PREPARING_RESTORE: 'preparingRestore',
  PREPARED_RESTORE: 'preparedRestore',
  FINALIZING_RESTORE: 'finalizingRestore',
};

export const RestoreResult = {
  FAILED: 'failed',
  PASSED: 'passed',
  NONE: 'none',
};

export const DefaultHumidifierValues = {
  HUMIDITIY_LEVEL: '',
  HUMIDIFIER_TIMEOUT: 60000,
};

export const HiddenCardTypes = [CardType.ENABLE_HUMIDIFIER];

export const HumidifierDoorStatus = {
  OPEN: 'Open',
  CLOSE: 'Close',
};

export const SoftwareUpdateResult = {
  FAILED: 'Failed',
  PASSED: 'Passed',
  NONE: 'None',
};

export const ServiceType = {
  INSTRUMENT: 'instrument',
  LABWARE: 'labware',
};

export const VolumeModalType = {
  BROADCAST: 'Broadcast',
  NORMALIZATION: 'Normalization',
  POOLING: 'Pooling',
};

export const TipCaddyType = {
  HIGH_VOLUME_CADDY: 'highVolumeTipCaddy',
  LOW_VOLUME_CADDY: 'lowVolumeTipCaddy',
};

export const AllowedPagesForBanner = [ViewMode.LOGIN];

export const InstrumentStatusType = {
  OPERATIONAL: 'operational',
  NON_OPERATIONAL: 'non-operational',
  RUNNING: 'running',
  PAUSED: 'paused',
  NEED_USER_ATTENTION: 'needUserAttention',
};
